import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const KITCHEN =
    "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/xynarg0a_IMG_4557.jpg";
const OFFICE =
    "https://images.unsplash.com/photo-1586380560607-bf9cf9d54e5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwzfHx3b29kZW4lMjBvZmZpY2UlMjBkZXNrfGVufDB8fHx8MTc3Njg1NDQ4MHww&ixlib=rb-4.1.0&q=85";
const CUSTOM =
    "https://customer-assets.emergentagent.com/job_timber-workspace/artifacts/r9jnrw1s_IMG_4566.png";

const services = [
    {
        id: "konyha",
        label: "01",
        title: "Konyhabútor",
        image: KITCHEN,
        lead: "Egyedi konyhabútor tervezéstől a beépítésig.",
        body: "Egyedi konyhabútor készítése Pakson — otthona szívét testre szabva építjük meg. Megrendelőink elképzelései alapján dolgozunk, a látványtervtől a helyszíni beépítésig minden részletre figyelünk.",
        items: [],
    },
    {
        id: "iroda",
        label: "02",
        title: "Irodabútor",
        image: OFFICE,
        lead: "Egyedi irodabútor — íróasztalok és konferenciaasztalok.",
        body: "Egyedi irodabútor készítése igények szerint — irodai íróasztalokat és konferenciaasztalokat gyártunk vállalkozások és intézmények számára.",
        items: [],
    },
    {
        id: "egyedi",
        label: "03",
        title: "Egyedi asztalosmunka",
        image: CUSTOM,
        lead: "Beépített bútor és egyedi asztalosmunka.",
        body: "Beépített bútor, gardrób, könyvespolc, tárolórendszer és egyéb egyedi asztalosmunka — ha meg tudja rajzolni, mi meg tudjuk építeni.",
        items: [
            "Beépített bútor, beépített szekrények",
            "Gardróbok, tolóajtós szekrények",
            "Könyvtárak, polcrendszerek",
            "Lépcsők, lépcsőkorlátok",
            "Belsőépítészeti burkolatok",
        ],
    },
];

export default function Services() {
    return (
        <div data-testid="services-page">
            {/* Hero */}
            <section className="pt-20 pb-16 md:pt-28 md:pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <p className="overline">Szolgáltatások</p>
                    <h1 className="font-serif mt-5 text-5xl md:text-7xl lg:text-[96px] leading-[0.95] tracking-tight text-[#2C2724] max-w-4xl">
                        Három terület,
                        <br />
                        <span className="italic text-[#C98A4B]">
                            egyetlen mércével.
                        </span>
                    </h1>
                    <p className="mt-10 text-lg text-[#5C534D] max-w-2xl leading-relaxed">
                        Egyedi bútor készítése és bútorgyártás Pakson —
                        konyhabútor, irodabútor és beépített bútor három
                        területre osztva. Ha más típusú bútorra van szüksége,
                        arról is szívesen beszélgetünk.
                    </p>
                </div>
            </section>

            {/* Services list */}
            <section className="pb-24 md:pb-36">
                <div className="max-w-7xl mx-auto px-6 lg:px-12 space-y-24 md:space-y-36">
                    {services.map((s, i) => (
                        <div
                            key={s.id}
                            id={s.id}
                            data-testid={`service-block-${s.id}`}
                            className={`grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center ${
                                i % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""
                            }`}
                        >
                            <div className="lg:col-span-6 h-[420px] md:h-[560px] overflow-hidden relative group">
                                <img
                                    src={s.image}
                                    alt={`${s.title} — egyedi asztalosmunka BAU-Paks Kft. Paks`}
                                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1500ms] group-hover:scale-105"
                                />
                            </div>
                            <div className="lg:col-span-6">
                                <p className="font-serif text-sm text-[#C98A4B]">
                                    / {s.label}
                                </p>
                                <h2 className="font-serif mt-3 text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-[#2C2724]">
                                    {s.title}
                                </h2>
                                <p className="mt-5 text-lg text-[#4A3728] font-serif italic leading-snug">
                                    {s.lead}
                                </p>
                                <p className="mt-5 text-[#5C534D] leading-relaxed">
                                    {s.body}
                                </p>
                                <ul className="mt-8 space-y-3">
                                    {s.items.map((item) => (
                                        <li
                                            key={item}
                                            className="flex items-start gap-3 text-sm text-[#2C2724]"
                                        >
                                            <span className="mt-2 block w-6 h-px bg-[#C98A4B] flex-shrink-0" />
                                            <span>{item}</span>
                                        </li>
                                    ))}
                                </ul>
                                <Link
                                    to="/ajanlatkeres"
                                    data-testid={`service-cta-${s.id}`}
                                    className="inline-flex items-center gap-2 mt-10 text-sm font-semibold tracking-wide text-[#4A3728] border-b border-[#4A3728] pb-1 hover:text-[#C98A4B] hover:border-[#C98A4B] transition-colors"
                                >
                                    Ajánlatkérés ehhez a szolgáltatáshoz
                                    <ArrowUpRight size={14} />
                                </Link>
                            </div>
                        </div>
                    ))}
                </div>
            </section>

            {/* Process */}
            <section className="bg-[#F3EBE1] py-24 md:py-32">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <p className="overline">Hogyan dolgozunk</p>
                    <h2 className="font-serif mt-5 text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight text-[#2C2724] max-w-3xl">
                        Négy lépés a
                        <span className="italic text-[#C98A4B]">
                            {" "}
                            kész bútorig.
                        </span>
                    </h2>
                    <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
                        {[
                            {
                                n: "01",
                                t: "Egyeztetés",
                                b: "Bejön a műhelybe vagy felkeressük Önt. Meghallgatjuk az igényeket, ötleteket.",
                            },
                            {
                                n: "02",
                                t: "Terv és ajánlat",
                                b: "3D-s látványterv, pontos árajánlat, anyagminták — minden kézzelfogható.",
                            },
                            {
                                n: "03",
                                t: "Műhelymunka",
                                b: "A saját üzemünkben elkészül a bútor. Közben folyamatos fotódokumentáció.",
                            },
                            {
                                n: "04",
                                t: "Beépítés",
                                b: "Helyszíni beépítés, finomhangolás, garanciával minden darabra.",
                            },
                        ].map((p) => (
                            <div
                                key={p.n}
                                data-testid={`process-${p.n}`}
                                className="border-t border-[#4A3728]/30 pt-6"
                            >
                                <p className="font-serif text-5xl text-[#C98A4B] leading-none">
                                    {p.n}
                                </p>
                                <h3 className="font-serif text-2xl mt-5 text-[#2C2724]">
                                    {p.t}
                                </h3>
                                <p className="mt-3 text-sm text-[#5C534D] leading-relaxed">
                                    {p.b}
                                </p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </div>
    );
}
